export default __webpack_public_path__ + "static/media/take_test.162dfaf5.png";